import { Menu } from "lucide-react";

export interface MobileMenuButtonProps {
  onClick: () => void;
}

export function MobileMenuButton({ onClick }: MobileMenuButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="mr-2 rounded-md p-1.5 text-muted hover:bg-gray-100 hover:text-gray-700 dark:hover:bg-gray-800 dark:hover:text-gray-200 lg:hidden"
      aria-label="Toggle navigation menu"
    >
      <Menu className="h-5 w-5" aria-hidden="true" />
    </button>
  );
}
